import { render, staticRenderFns } from "./BaseNewRegisterButton.vue?vue&type=template&id=4fbd2935&"
import script from "./BaseNewRegisterButton.vue?vue&type=script&lang=js&"
export * from "./BaseNewRegisterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports